const getUrlParams = (val)=> {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const param = urlParams.get(val);
  return param;
}

export default getUrlParams;